import { useTranslation } from "react-i18next";
import HorizontalScroll from "react-scroll-horizontal";

import WorkData from "../components/ContentContainer/WorkData";

const Work = () => {
  const { t } = useTranslation();
  return (
    <HorizontalScroll style={{ overflowX: "scroll" }} reverseScroll={true} config={{ stiffness: 25, damping: 10 }}>
      {t("workExp", { returnObjects: true }).map((item, index, array) => (
        <section
          className={`work-section ${index === 0 ? "redtic" : ""} ${index === 1 ? "comdata" : ""} ${index === 2 ? "intelcia" : ""} ${index === array.length - 1 ? "ofppt" : ""}
        }`}
          key={index}
        >
          <WorkData title={item.title} image={item.image} description={item.description} date={item.date} link={item.link} />
        </section>
      ))}
    </HorizontalScroll>
  );
};

export default Work;
